import ContentHelp from '@flatsy/core/Content/Help'
import Separator from '@flatsy/core/Layout/Separator'
import i18n from '@flatsy/utils/translations'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export const renderVerlingue = (isVerlingue: boolean | undefined): React.ReactNode => {
  if (isVerlingue === true) {
    return (
      <>
        <Separator size="16px" />
        <ContentHelp icon={<InfoOutlinedIcon />} severity="info">
          {i18n.t(
            'to_finalise_the_solvency_assessment_of_your_application_our_secure_file_certification_service_will_send_you_an_e-mail_shortly_after_your_viewing'
          )}
        </ContentHelp>
      </>
    )
  }
}
